import {Pipe, PipeTransform} from '@angular/core';
import moment from "moment";

@Pipe({standalone: true, name: 'wmCalendarFormat'})
export class WmCalendarFormatPipe implements PipeTransform {
    transform(value: moment.MomentInput): string {
        return moment(value).calendar();
    }
}

